import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Modal, Spinner, Nav, Button, Row, Col } from "react-bootstrap";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import { nanoid } from "nanoid";
import LanguageIcon from "@mui/icons-material/Language";
import "styles/catalog.css";
import { useTranslation } from "react-i18next";
import { addCart } from "../redux/handlers/catalog/addCart.handler";
import { useMediaQuery, Stack, Badge, Tooltip, Chip, Box, Popper, Grow, Paper, MenuList, MenuItem, ClickAwayListener } from "@mui/material";
import { useTheme } from "@mui/material/styles";
//redux
import { getProductType } from "../redux/handlers/master/getProductType.handler";
import { getCategory } from "../redux/handlers/master/getCategory.handler";
import { getSubCategory } from "../redux/handlers/master/getSubCategory.handler";
import { getCatalog } from "../redux/handlers/catalog/getCatalog.handler";
import { getShopBranch } from "../redux/handlers/catalog/getShopBranch.handler";
import { getGuest } from "../redux/handlers/catalog/getGuest.handler";
import { getMstBrandCate } from "../redux/handlers/master/getMstBrandCate.handler";
import { myCart } from "../redux/handlers/catalog/myCart.handler";
import { getSocialContact } from "../redux/handlers/catalog/getSocialContact.handler";
import { summaryCatalog } from "../redux/handlers/catalog/summaryCatalog.handler";
function getDeviceId() {
    var deviceId = localStorage.getItem("device_id");
    localStorage.removeItem("guest_id");
    if (!deviceId) {
        // Generate a pseudo-unique ID (not truly unique or secure)
        deviceId = Math.random().toString(36).substr(2, 9) + "-" + Date.now();
        localStorage.setItem("device_id", deviceId);
    }
    return deviceId;
}
var PAGE_SIZE = 20;
var normalizeQuantityInput = function(rawValue) {
    if (rawValue === "") return "";
    var digitsOnly = String(rawValue).replace(/\D/g, "");
    return digitsOnly.replace(/^0+(?=\d)/, "");
};
export function Catalog() {
    var _getCatalogReducer_data_data_, _getCatalogReducer_data;
    var param = useParams();
    var navigate = useNavigate();
    var theme = useTheme();
    var scrollRef = useRef(null);
    var bottomRef = useRef(null);
    var anchorRef = useRef(null);
    var hasCatalogScrollStartedRef = useRef(false);
    var loadMoreLockRef = useRef(false);
    var location = useLocation();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var isMobile = useMediaQuery(theme.breakpoints.down("md"));
    // State
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), appliedFilterText = _useState1[0], setAppliedFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), filterCode = _useState2[0], setFilterCode = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), shopBranch = _useState3[0], setShopBranch = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), rowData = _useState4[0], setRowData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), page = _useState5[0], setPage = _useState5[1];
    var _useState6 = _sliced_to_array(useState(true), 2), hasMore = _useState6[0], setHasMore = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), isSearching = _useState7[0], setIsSearching = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), tabStatus = _useState8[0], setTabStatus = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), tabBrandType = _useState9[0], setTabBrandType = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), tabPdType = _useState10[0], setTabPdType = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), tabCateType = _useState11[0], setTabCateType = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), tabSubCateType = _useState12[0], setTabSubCateType = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), brandType = _useState13[0], setBrandType = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), productType = _useState14[0], setProductType = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), typeCategory = _useState15[0], setTypeCategory = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), typeSubCategory = _useState16[0], setTypeSubCategory = _useState16[1];
    var _useState17 = _sliced_to_array(useState(null), 2), guestId = _useState17[0], setGuestId = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), cartLength = _useState18[0], setCartLength = _useState18[1];
    var _useState19 = _sliced_to_array(useState(false), 2), loading = _useState19[0], setLoading = _useState19[1];
    var _useState20 = _sliced_to_array(useState(false), 2), modalsuccess = _useState20[0], setModalsuccess = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), textsuccess = _useState21[0], setTextsuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState(false), 2), isSearchingBranch = _useState22[0], setIsSearchingBranch = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), ip = _useState23[0], setIp = _useState23[1];
    var _useState24 = _sliced_to_array(useState(""), 2), userAgent = _useState24[0], setUserAgent = _useState24[1];
    var _useState25 = _sliced_to_array(useState(""), 2), platform = _useState25[0], setPlatform = _useState25[1];
    var _useState26 = _sliced_to_array(useState(""), 2), deviceId = _useState26[0], setDeviceId = _useState26[1];
    var _useState27 = _sliced_to_array(useState(false), 2), isLoadingMore = _useState27[0], setIsLoadingMore = _useState27[1];
    var _useState28 = _sliced_to_array(useState(false), 2), open = _useState28[0], setOpen = _useState28[1];
    var _useState29 = _sliced_to_array(useState([]), 2), socialContact = _useState29[0], setSocialContact = _useState29[1];
    var _useState30 = _sliced_to_array(useState([]), 2), summary = _useState30[0], setSummary = _useState30[1];
    var _useState31 = _sliced_to_array(useState(false), 2), showToTop = _useState31[0], setShowToTop = _useState31[1];
    var _useState32 = _sliced_to_array(useState({}), 2), brandData = _useState32[0], setBrandData = _useState32[1];
    var _useState33 = _sliced_to_array(useState({}), 2), producttypeData = _useState33[0], setProducttypeData = _useState33[1];
    var _useState34 = _sliced_to_array(useState({}), 2), categoryData = _useState34[0], setCategoryData = _useState34[1];
    var _useState35 = _sliced_to_array(useState({}), 2), categorysubData = _useState35[0], setCategorysubData = _useState35[1];
    // Redux reducers
    var getGuestReducer = useAppSelector(function(state) {
        return state.getGuestReducer;
    });
    var getCatalogReducer = useAppSelector(function(state) {
        return state.getCatalogReducer;
    });
    var addCartReducer = useAppSelector(function(state) {
        return state.addCartReducer;
    });
    var myCartReducer = useAppSelector(function(state) {
        return state.myCartReducer;
    });
    var getShopBranchReducer = useAppSelector(function(state) {
        return state.getShopBranchReducer;
    });
    var getMstBrandCateReducer = useAppSelector(function(state) {
        return state.getMstBrandCateReducer;
    });
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    var getSocialContactReducer = useAppSelector(function(state) {
        return state.getSocialContactReducer;
    });
    var summaryCatalogReducer = useAppSelector(function(state) {
        return state.summaryCatalogReducer;
    });
    useEffect(function() {
        // ดัก redirect ถ้าไม่มี query ?openExternalBrowser=1
        var params = new URLSearchParams(location.search);
        if (params.get("openExternalBrowser") != "1") {
            window.location.href = window.location.origin + location.pathname + "?openExternalBrowser=1";
        }
    }, [
        location
    ]);
    useEffect(function() {
        // Collect some unique-ish info from navigator
        setUserAgent(navigator.userAgent);
        setPlatform(navigator.platform);
        // Get or generate device ID
        setDeviceId(getDeviceId());
        // Fetch public IP address
        fetch("https://api.ipify.org?format=json").then(function(res) {
            return res.json();
        }).then(function(data) {
            return setIp(data.ip);
        }).catch(function(err) {
        // console.error("Failed to get IP address:", err);
        // setIp("Unavailable");
        });
    }, []);
    useEffect(function() {
        if (ip !== "" && userAgent !== "" && platform !== "" && deviceId !== "") {
            var data = {
                ip: ip,
                useragent: userAgent,
                platform: platform,
                deviceid: deviceId
            };
            dispatch(getGuest(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        ip,
        userAgent,
        platform,
        deviceId
    ]);
    // useEffect สำหรับ getGuestReducer
    useEffect(function() {
        setLoading(getGuestReducer.isFetching);
        if (getGuestReducer.data) {
            var newData = getGuestReducer.data.data;
            if (newData.length === 0) {
                setGuestId(null);
            } else {
                setGuestId(newData.sys_guest_id);
            }
        }
    }, [
        getGuestReducer
    ]);
    var typeShop = useMemo(function() {
        return param.typeShop || null;
    }, [
        param.typeShop
    ]);
    var typeId = String(typeShop).toLowerCase() === "all" ? 0 : typeShop == "RT" && 1 || typeShop == "WT" && 1 || typeShop == "MT" && 3 || typeShop == "rt" && 1 || typeShop == "wt" && 1 || typeShop == "mt" && 3 || null;
    useEffect(function() {
        if (guestId != null && typeId != null && shopBranch) {
            localStorage.setItem("guest_id", guestId);
            var cart = {
                guestid: parseInt(guestId),
                shopid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
                shbranchid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id)
            };
            dispatch(myCart(cart, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        guestId,
        typeId,
        shopBranch
    ]);
    var cartUrl = useMemo(function() {
        var params = new URLSearchParams();
        params.set("openExternalBrowser", "1");
        if (typeShop) params.set("typeShop", typeShop);
        if (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid) {
            params.set("shopid", String(shopBranch.sh_branch_shid));
        }
        if (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id) {
            params.set("branchid", String(shopBranch.sh_branch_id));
        }
        if (shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_vatcal) {
            params.set("vatcal", String(shopBranch.sh_branch_vatcal));
        }
        return "/cart/".concat(guestId, "?").concat(params.toString());
    }, [
        guestId,
        shopBranch,
        typeShop
    ]);
    // ตั้งค่า 2 ภาษา
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var _useState36 = _sliced_to_array(useState(!localStorage.getItem("lang") ? "th" : localStorage.getItem("lang")), 2), language = _useState36[0], setLanguage = _useState36[1];
    var onClickLanguage = function() {
        if (language == "th") {
            setLanguage("la");
        } else {
            setLanguage("th");
        }
    };
    useEffect(function() {
        i18n.changeLanguage(language);
        localStorage.setItem("lang", language);
    }, [
        language
    ]);
    useEffect(function() {
        var savedLang = localStorage.getItem("lang");
        if (savedLang) i18n.changeLanguage(savedLang);
    }, [
        i18n
    ]);
    // แปลง typeId
    var bookid = parseInt(getCatalogReducer === null || getCatalogReducer === void 0 ? void 0 : (_getCatalogReducer_data = getCatalogReducer.data) === null || _getCatalogReducer_data === void 0 ? void 0 : (_getCatalogReducer_data_data_ = _getCatalogReducer_data.data[0]) === null || _getCatalogReducer_data_data_ === void 0 ? void 0 : _getCatalogReducer_data_data_.cl_catalog_bookid);
    var dataCate = {
        bookid: !isNaN(bookid) ? bookid : undefined,
        branchid: Number(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id) || undefined,
        typeshop: typeId !== null && typeId !== void 0 ? typeId : undefined
    };
    useEffect(function() {
        dispatch(getSocialContact({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        if (typeId != null) {
            dispatch(summaryCatalog(dataCate, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        bookid,
        shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id,
        typeId
    ]);
    // useEffect สำหรับโหลดข้อมูล Brand, ProductType, Category, SubCategory
    useEffect(function() {
        if (typeId == null) return;
        var ts = Number(tabStatus);
        // โหลด Brand เมื่ออยู่ในแท็บ Brand
        if (ts === 4) {
            dispatch(getMstBrandCate());
        }
        // โหลด ProductType เมื่ออยู่ในแท็บ Product Type
        if (ts === 5) {
            dispatch(getProductType());
            // โหลด Category เมื่อเลือก ProductType แล้ว
            if (tabPdType !== 0) {
                dispatch(getCategory(parseInt(tabPdType)));
                // โหลด SubCategory เมื่อเลือก Category แล้ว
                if (tabCateType !== 0) {
                    dispatch(getSubCategory(parseInt(tabPdType), parseInt(tabCateType)));
                }
            }
        }
    }, [
        typeId,
        tabStatus,
        tabPdType,
        tabCateType
    ]);
    // useEffect Initial Load
    useEffect(function() {
        if (typeId == null) {
            navigate("/404", {
                replace: true
            });
            return;
        }
        // Reset เมื่อเปลี่ยน filter
        hasCatalogScrollStartedRef.current = false;
        loadMoreLockRef.current = false;
        setIsLoadingMore(false);
        setRowData([]);
        setPage(0);
        setHasMore(true);
        var ts = Number(tabStatus); // ← แปลงเป็น number
        var cate = _object_spread({
            skip: 0,
            typeshop: parseInt(typeId),
            shopid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
            branchid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id),
            searchtext: appliedFilterText || ""
        }, ts === 1 && {
            statusrecom: 1
        }, ts === 2 && {
            statusnew: 1
        }, ts === 3 && {
            promotion: 1
        }, ts === 4 && {
            brandid: parseInt(tabBrandType)
        }, ts === 5 && {
            producttypeid: parseInt(tabPdType),
            categoryid: parseInt(tabCateType),
            categorysubid: parseInt(tabSubCateType)
        });
        dispatch(getCatalog(cate, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        typeId,
        tabStatus,
        tabPdType,
        tabCateType,
        tabSubCateType,
        tabBrandType,
        shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid,
        shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id,
        shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_grade
    ]);
    useEffect(function() {
        if (!isLoadingMore || page === 0) return;
        var ts = Number(tabStatus); // ← แปลงเป็น number
        var cate = _object_spread({
            skip: page * PAGE_SIZE,
            typeshop: parseInt(typeId),
            shopid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
            branchid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id),
            searchtext: appliedFilterText || ""
        }, ts === 1 && {
            statusrecom: 1
        }, ts === 2 && {
            statusnew: 1
        }, ts === 3 && {
            promotion: 1
        }, ts === 4 && {
            brandid: parseInt(tabBrandType)
        }, ts === 5 && {
            producttypeid: parseInt(tabPdType),
            categoryid: parseInt(tabCateType),
            categorysubid: parseInt(tabSubCateType)
        });
        dispatch(getCatalog(cate, {
            modalObj: modalObj,
            setModalObj: setModalObj
        })).finally(function() {
            loadMoreLockRef.current = false;
            setIsLoadingMore(false);
        });
    }, [
        isLoadingMore,
        page
    ]);
    // IntersectionObserver
    useEffect(function() {
        if (!hasMore || loading || getCatalogReducer.isFetching || getCatalogReducer.isError || isLoadingMore) {
            return;
        }
        var threshold = 80;
        var getRemainingScroll = function() {
            if (isMobile) {
                var doc = document.documentElement;
                return doc.scrollHeight - (window.innerHeight + window.scrollY);
            }
            var target = scrollRef.current;
            if (!target) return Infinity;
            return target.scrollHeight - (target.scrollTop + target.clientHeight);
        };
        var scrollTarget = isMobile ? window : scrollRef.current;
        var markUserScrolled = function() {
            hasCatalogScrollStartedRef.current = true;
        };
        scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.addEventListener("scroll", markUserScrolled, {
            passive: true
        });
        var observer = new IntersectionObserver(function(param) {
            var _param = _sliced_to_array(param, 1), entry = _param[0];
            if (entry.isIntersecting && hasCatalogScrollStartedRef.current && getRemainingScroll() <= threshold && !loadMoreLockRef.current && !loading && hasMore && !isLoadingMore) {
                loadMoreLockRef.current = true;
                setIsLoadingMore(true);
                setPage(function(prev) {
                    return prev + 1;
                }); // ← เพิ่มทีละ 1
            }
        }, {
            root: scrollRef.current,
            threshold: 1.0
        });
        if (bottomRef.current) {
            observer.observe(bottomRef.current);
        }
        return function() {
            scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.removeEventListener("scroll", markUserScrolled);
            if (bottomRef.current) observer.unobserve(bottomRef.current);
        };
    }, [
        isMobile,
        loading,
        hasMore,
        isLoadingMore,
        getCatalogReducer.isFetching,
        getCatalogReducer.isError
    ]);
    useEffect(function() {
        var scrollTarget = isMobile ? window : scrollRef.current;
        if (!scrollTarget) return undefined;
        var handleToTopVisibility = function() {
            var _scrollRef_current;
            var scrollTop = isMobile ? window.scrollY || document.documentElement.scrollTop : ((_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTop) || 0;
            setShowToTop(scrollTop > 300);
        };
        handleToTopVisibility();
        scrollTarget.addEventListener("scroll", handleToTopVisibility, {
            passive: true
        });
        return function() {
            scrollTarget.removeEventListener("scroll", handleToTopVisibility);
        };
    }, [
        isMobile
    ]);
    var scrollCatalogToTop = function() {
        var _scrollRef_current;
        if (isMobile) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return;
        }
        (_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    useEffect(function() {
        if (!hasMore || loading || getCatalogReducer.isFetching || getCatalogReducer.isError || isLoadingMore) {
            return;
        }
        var threshold = 160;
        var getRemainingScroll = function() {
            if (isMobile) {
                var doc = document.documentElement;
                return doc.scrollHeight - (window.innerHeight + window.scrollY);
            }
            var target = scrollRef.current;
            if (!target) return Infinity;
            return target.scrollHeight - (target.scrollTop + target.clientHeight);
        };
        var requestLoadMore = function() {
            hasCatalogScrollStartedRef.current = true;
            if (loadMoreLockRef.current || getRemainingScroll() > threshold) {
                return;
            }
            loadMoreLockRef.current = true;
            setIsLoadingMore(true);
            setPage(function(prev) {
                return prev + 1;
            });
        };
        var scrollTarget = isMobile ? window : scrollRef.current;
        if (!scrollTarget) {
            return;
        }
        scrollTarget.addEventListener("scroll", requestLoadMore, {
            passive: true
        });
        return function() {
            scrollTarget.removeEventListener("scroll", requestLoadMore);
        };
    }, [
        isMobile,
        loading,
        hasMore,
        isLoadingMore,
        getCatalogReducer.isFetching,
        getCatalogReducer.isError
    ]);
    // เช็ค typeId กับ localStorage
    useEffect(function() {
        var savedShop = localStorage.getItem("shop_reserve");
        if (!savedShop) {
            setShopBranch(null);
            return;
        }
        var parsedShop = null;
        try {
            parsedShop = JSON.parse(savedShop);
        } catch (err) {
            parsedShop = null;
        }
        // ถ้า parse ไม่ได้หรือเป็น null → clear
        if (!parsedShop || !parsedShop.shShop) {
            localStorage.removeItem("shop_reserve");
            setShopBranch(null);
            return;
        }
        var shopType = parseInt(parsedShop.shShop.sh_shop_typeshop);
        // ตรวจสอบ typeId ปัจจุบัน
        var typeMatch = typeId === 0 || shopType === 1 && typeId === 1 || shopType === 2 && typeId === 1 || shopType === 3 && typeId === 3;
        if (!typeMatch) {
            localStorage.removeItem("shop_reserve");
            setShopBranch(null);
        } else {
            setShopBranch(parsedShop);
        }
    }, [
        typeId,
        isSearchingBranch
    ]);
    // ข้อมูลแคตตาล็อกสินค้า
    useEffect(function() {
        setLoading(getCatalogReducer.isFetching);
        if (getCatalogReducer.isError) {
            loadMoreLockRef.current = false;
            setHasMore(false);
            setIsLoadingMore(false);
            setIsSearching(false);
            return;
        }
        if (getCatalogReducer.data) {
            var newData = getCatalogReducer.data.data.map(function(catalog) {
                return _object_spread_props(_object_spread({}, catalog), {
                    ClDetail: (catalog.ClDetail || []).map(function(detail) {
                        return _object_spread_props(_object_spread({}, detail), {
                            SetUnit: detail.SetUnit || {},
                            idDetail: nanoid(),
                            cl_detail_amount: 0
                        });
                    })
                });
            });
            // ถ้า isSearching = true หรือ page = 0 → replace rowData
            if (isSearching || page === 0) {
                setRowData(newData);
                setIsSearching(false);
            } else {
                // merge ปกติ (scroll load more)
                setRowData(function(prev) {
                    var existingIds = new Set(prev.map(function(item) {
                        return item.cl_catalog_id;
                    }));
                    var filteredData = newData.filter(function(item) {
                        return !existingIds.has(item.cl_catalog_id);
                    });
                    return _to_consumable_array(prev).concat(_to_consumable_array(filteredData));
                });
            }
            setHasMore(newData.length === PAGE_SIZE);
        }
    }, [
        getCatalogReducer,
        isSearching,
        page
    ]);
    // ติดต่อห
    useEffect(function() {
        setIsLoading(getSocialContactReducer.isFetching);
        if (getSocialContactReducer.data) {
            setSocialContact(getSocialContactReducer.data.data);
        }
    }, [
        getSocialContactReducer
    ]);
    useEffect(function() {
        setIsLoading(summaryCatalogReducer.isFetching);
        if (summaryCatalogReducer.data) {
            setSummary(summaryCatalogReducer.data.data);
        }
    }, [
        summaryCatalogReducer
    ]);
    // ข้อมูลประเภทสินค้า หมวดหมู่ หลัก/ย่อย
    useEffect(function() {
        setIsLoading(getProductTypeReducer.isFetching || getCategoryReducer.isFetching || getSubCategoryReducer.isFetching || getMstBrandCateReducer.isFetching);
        if (tabStatus == 4) {
            if (getMstBrandCateReducer.data) {
                setBrandType(getMstBrandCateReducer.data.data);
            }
        }
        if (tabStatus == 5) {
            if (getProductTypeReducer.data) {
                setProductType(getProductTypeReducer.data.data);
            }
            if (tabPdType != 0) {
                if (getCategoryReducer.data) {
                    setTypeCategory(getCategoryReducer.data.data);
                }
                if (tabCateType != 0) {
                    if (getSubCategoryReducer.data) {
                        setTypeSubCategory(getSubCategoryReducer.data.data);
                    }
                }
            }
        }
    }, [
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        getCatalogReducer,
        getMstBrandCateReducer,
        tabStatus,
        tabPdType,
        tabCateType
    ]);
    // เพิ่มรายการสินค้าลงตะกร้า
    useEffect(function() {
        setIsLoading(addCartReducer.isFetching);
        if (guestId) {
            if (addCartReducer.data && !addCartReducer.isError) {
                var cart = {
                    guestid: parseInt(guestId),
                    shopid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
                    shbranchid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id)
                };
                dispatch(myCart(cart, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setTextsuccess(t("successfully added cart"));
                setModalsuccess(true);
            }
        }
    }, [
        addCartReducer,
        guestId
    ]);
    // รายการจำนวนสินค้าในตะกร้า
    useEffect(function() {
        setIsLoading(myCartReducer.isFetching);
        if (myCartReducer.data) {
            var newData = myCartReducer.data.data;
            setCartLength(newData.length);
        }
    }, [
        myCartReducer
    ]);
    var onClickCart = function(row) {
        if (!guestId || !shopBranch) return;
        var detailArr = row.ClDetail.map(function(ele) {
            return {
                detailid: parseInt(ele.cl_detail_id),
                amount: parseInt(ele.cl_detail_amount) || 0
            };
        });
        var cartPayload = {
            guestid: parseInt(guestId),
            catalogid: parseInt(row.cl_catalog_id),
            detail: detailArr,
            shopid: parseInt(shopBranch.sh_branch_shid),
            shbranchid: parseInt(shopBranch.sh_branch_id)
        };
        setModalsuccess(false);
        dispatch(addCart(cartPayload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    // Buttonn กดค้นหาสินค้า
    var loadSearchPin = function() {
        if (typeId == null) return;
        hasCatalogScrollStartedRef.current = false;
        loadMoreLockRef.current = false;
        setRowData([]);
        setPage(0);
        setHasMore(true);
        setAppliedFilterText(filterText);
        var ts = Number(tabStatus);
        var cate = _object_spread({
            skip: 0,
            typeshop: parseInt(typeId),
            shopid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_shid),
            branchid: parseInt(shopBranch === null || shopBranch === void 0 ? void 0 : shopBranch.sh_branch_id),
            searchtext: filterText
        }, ts === 1 && {
            statusrecom: 1
        }, ts === 2 && {
            statusnew: 1
        }, ts === 3 && {
            promotion: 1
        }, ts === 4 && {
            brandid: parseInt(tabBrandType)
        }, ts === 5 && {
            producttypeid: parseInt(tabPdType),
            categoryid: parseInt(tabCateType),
            categorysubid: parseInt(tabSubCateType)
        });
        if (ts === 4) dispatch(getMstBrandCate());
        if (ts === 5) {
            dispatch(getProductType());
            if (tabPdType !== 0) {
                dispatch(getCategory(parseInt(tabPdType)));
                if (tabCateType !== 0) {
                    dispatch(getSubCategory(parseInt(tabPdType), parseInt(tabCateType)));
                }
            }
        }
        dispatch(getCatalog(cate, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var loadSearchBranch = function() {
        if (filterCode == "" || filterCode == null || filterCode == undefined) return;
        setIsSearchingBranch(true); // ป้องกัน useEffect แรกยิงซ้ำ
        localStorage.removeItem("shop_reserve");
        dispatch(getShopBranch({
            code: filterCode,
            typeshop: parseInt(typeId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        })).finally(function() {
            return setIsSearchingBranch(false);
        }); // ปล่อยให้ useEffect ยิงได้อีก
    };
    useEffect(function() {
        setIsLoading(getShopBranchReducer.isFetching);
        if (getShopBranchReducer.data) {
            var newData = getShopBranchReducer.data.data;
            localStorage.setItem("shop_reserve", JSON.stringify(newData));
        }
    }, [
        getShopBranchReducer
    ]);
    useEffect(function() {
        if (localStorage.getItem("shop_reserve") != undefined && localStorage.getItem("shop_reserve") != null && localStorage.getItem("shop_reserve") != "") {
            var newData = JSON.parse(localStorage.getItem("shop_reserve"));
            setShopBranch(newData);
        } else {
            setShopBranch("");
        }
    }, [
        localStorage.getItem("shop_reserve")
    ]);
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var handleClose = function(event) {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    }
    // ดึงข้อมูลจาก summary
    var mainCounts = useMemo(function() {
        if (summary && summary.length > 0) {
            var _firstItem_totalProducts, _firstItem_totalRecommend, _firstItem_totalNew, _firstItem_totalPromotion, _firstItem_totalDelete;
            var firstItem = summary[0];
            // รวมจำนวนสินค้าทั้งหมดใน brand
            var totalBrand = 0;
            summary.forEach(function(item) {
                if (item.brand) {
                    item.brand.forEach(function(b) {
                        totalBrand += b.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน producttype
            var totalProductType = 0;
            summary.forEach(function(item) {
                if (item.producttype) {
                    item.producttype.forEach(function(p) {
                        totalProductType += p.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน category
            var totalCategory = 0;
            summary.forEach(function(item) {
                if (item.category) {
                    item.category.forEach(function(c) {
                        totalCategory += c.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน categorysub
            var totalCategorySub = 0;
            summary.forEach(function(item) {
                if (item.categorysub) {
                    item.categorysub.forEach(function(cs) {
                        totalCategorySub += cs.totalProducts || 0;
                    });
                }
            });
            return {
                total: ((_firstItem_totalProducts = firstItem.totalProducts) === null || _firstItem_totalProducts === void 0 ? void 0 : _firstItem_totalProducts.cl_catalog_id) || 0,
                recommend: ((_firstItem_totalRecommend = firstItem.totalRecommend) === null || _firstItem_totalRecommend === void 0 ? void 0 : _firstItem_totalRecommend.cl_catalog_id) || 0,
                new: ((_firstItem_totalNew = firstItem.totalNew) === null || _firstItem_totalNew === void 0 ? void 0 : _firstItem_totalNew.cl_catalog_id) || 0,
                promotion: ((_firstItem_totalPromotion = firstItem.totalPromotion) === null || _firstItem_totalPromotion === void 0 ? void 0 : _firstItem_totalPromotion.cl_catalog_id) || 0,
                deleted: ((_firstItem_totalDelete = firstItem.totalDelete) === null || _firstItem_totalDelete === void 0 ? void 0 : _firstItem_totalDelete.cl_catalog_id) || 0,
                brand: totalBrand,
                productType: totalProductType,
                category: totalCategory,
                categorySub: totalCategorySub
            };
        }
        return {
            total: 0,
            recommend: 0,
            new: 0,
            promotion: 0,
            deleted: 0,
            brand: 0,
            productType: 0,
            category: 0,
            categorySub: 0
        };
    }, [
        summary
    ]);
    var sortedBrandType = useMemo(function() {
        var brandField = language == "la" ? "set_brand_namela" : "set_brand_name";
        var locale = language == "la" ? "lo" : "th";
        return _to_consumable_array(brandType).sort(function(a, b) {
            var firstName = ((a === null || a === void 0 ? void 0 : a[brandField]) || (a === null || a === void 0 ? void 0 : a.set_brand_name) || "").trim();
            var secondName = ((b === null || b === void 0 ? void 0 : b[brandField]) || (b === null || b === void 0 ? void 0 : b.set_brand_name) || "").trim();
            return firstName.localeCompare(secondName, locale, {
                sensitivity: "base"
            });
        });
    }, [
        brandType,
        language
    ]);
    // numberMappingDataSummary
    useEffect(function() {
        try {
            // Brand
            var mappingBrand = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_brand;
                (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.forEach(function(b) {
                    mappingBrand[b.id] = b.totalProducts;
                });
            });
            setBrandData(mappingBrand);
            // Producttype
            var mappingProducttype = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_producttype;
                (_item_producttype = item.producttype) === null || _item_producttype === void 0 ? void 0 : _item_producttype.forEach(function(b) {
                    mappingProducttype[b.id] = b.totalProducts;
                });
            });
            setProducttypeData(mappingProducttype);
            var mappingCatalog = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_category;
                (_item_category = item.category) === null || _item_category === void 0 ? void 0 : _item_category.forEach(function(b) {
                    mappingCatalog[b.id] = b.totalProducts;
                });
            });
            setCategoryData(mappingCatalog);
            var mappingSubCatalog = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_categorysub;
                (_item_categorysub = item.categorysub) === null || _item_categorysub === void 0 ? void 0 : _item_categorysub.forEach(function(b) {
                    mappingSubCatalog[b.id] = b.totalProducts;
                });
            });
            setCategorysubData(mappingSubCatalog);
        } catch (error) {
            console.error("Error fetching brand data:", error);
        }
    }, [
        summary
    ]);
    useEffect(function() {
        if (Number(tabStatus) === 4 && Number(tabBrandType) > 0 && summaryCatalogReducer.data && Number(brandData[tabBrandType] || 0) === 0) {
            setTabBrandType(0);
        }
    }, [
        brandData,
        summaryCatalogReducer.data,
        tabBrandType,
        tabStatus
    ]);
    // แสดงผล Tab Brand
    var renderBrandTabs = function() {
        return sortedBrandType.filter(function(brand) {
            return Number(brandData[brand.set_brand_id] || 0) > 0;
        }).map(function(brand) {
            var totalProducts = brandData[brand.set_brand_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: brand.set_brand_id,
                    children: [
                        language == "la" ? brand.set_brand_namela : brand.set_brand_name,
                        " (",
                        totalProducts,
                        ")"
                    ]
                })
            }, brand.set_brand_id);
        });
    };
    // แสดงผล Tab Producttype
    var renderProducttypeTabs = function() {
        return productType.map(function(pd) {
            var totalProducts = producttypeData[pd.set_producttype_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_producttype_id,
                    children: [
                        language == "la" ? pd.set_producttype_namela ? pd.set_producttype_namela : pd.set_producttype_name : pd.set_producttype_name,
                        "(",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_producttype_id);
        });
    };
    // แสดงผล Tab Category
    var renderCategoryTabs = function() {
        return typeCategory.map(function(pd) {
            var totalProducts = categoryData[pd.set_productcategory_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_productcategory_id,
                    children: [
                        language == "la" ? pd.set_productcategory_namela ? pd.set_productcategory_namela : pd.set_productcategory_name : pd.set_productcategory_name,
                        "(",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_productcategory_id);
        });
    };
    // แสดงผล Tab SubCategory
    var renderSubCategoryTabs = function() {
        return typeSubCategory.map(function(pd) {
            var totalProducts = categorysubData[pd.set_productcategorysub_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_productcategorysub_id,
                    children: [
                        language == "la" ? pd.set_productcategorysub_namela ? pd.set_productcategorysub_namela : pd.set_productcategorysub_name : pd.set_productcategorysub_name,
                        "(",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_productcategorysub_id);
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-2 ",
        children: [
            /*#__PURE__*/ _jsx(Stack, {
                direction: "row",
                justifyContent: "space-between",
                children: !isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24 ".concat(!isMobile ? "mb-4" : "mb-2"),
                            children: t("product catalog")
                        }),
                        /*#__PURE__*/ _jsxs(Box, {
                            children: [
                                /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            className: " btn btn-dg bt-width-120 me-3 pb-2",
                                            ref: anchorRef,
                                            id: "composition-button",
                                            "aria-controls": open ? "composition-menu" : undefined,
                                            "aria-expanded": open ? "true" : undefined,
                                            "aria-haspopup": "true",
                                            onClick: handleToggle,
                                            children: t("Contact Method")
                                        }),
                                        /*#__PURE__*/ _jsx(Popper, {
                                            open: open,
                                            anchorEl: anchorRef.current,
                                            role: undefined,
                                            placement: "bottom-start",
                                            transition: true,
                                            disablePortal: true,
                                            children: function(param) {
                                                var TransitionProps = param.TransitionProps, placement = param.placement;
                                                return /*#__PURE__*/ _jsx(Grow, _object_spread_props(_object_spread({}, TransitionProps), {
                                                    style: {
                                                        transformOrigin: placement === "bottom-start" ? "left top" : "left bottom"
                                                    },
                                                    children: /*#__PURE__*/ _jsx(Paper, {
                                                        children: /*#__PURE__*/ _jsx(ClickAwayListener, {
                                                            onClickAway: handleClose,
                                                            children: /*#__PURE__*/ _jsx(MenuList, {
                                                                autoFocusItem: open,
                                                                id: "composition-menu",
                                                                "aria-labelledby": "composition-button",
                                                                onKeyDown: handleListKeyDown,
                                                                children: socialContact.map(function(ele, i) {
                                                                    var _ele_SysSocial, _ele_SysSocial1;
                                                                    return /*#__PURE__*/ _jsxs(MenuItem, {
                                                                        onClick: handleClose,
                                                                        component: "a",
                                                                        href: (ele === null || ele === void 0 ? void 0 : ele.social_contact_link) || "",
                                                                        target: "_blank",
                                                                        className: "w-[120px]",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("img", {
                                                                                src: ele === null || ele === void 0 ? void 0 : (_ele_SysSocial = ele.SysSocial) === null || _ele_SysSocial === void 0 ? void 0 : _ele_SysSocial.sys_social_icon,
                                                                                className: "me-2",
                                                                                style: {
                                                                                    width: 20,
                                                                                    height: 20
                                                                                }
                                                                            }),
                                                                            ele === null || ele === void 0 ? void 0 : (_ele_SysSocial1 = ele.SysSocial) === null || _ele_SysSocial1 === void 0 ? void 0 : _ele_SysSocial1.sys_social_name
                                                                        ]
                                                                    }, i);
                                                                })
                                                            })
                                                        })
                                                    })
                                                }));
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Tooltip, {
                                    title: t("change language"),
                                    onClick: function(e) {
                                        return onClickLanguage();
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(LanguageIcon, {
                                            style: {
                                                fontSize: 30,
                                                cursor: "pointer"
                                            },
                                            className: "me-2"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: language == "th" ? "ภาษาไทย" : "ພາສາລາວ"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "fs-24 ".concat(!isMobile ? "mb-4" : "mb-2"),
                                    children: t("product catalog")
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 6,
                                md: 6,
                                lg: 6,
                                xl: 6,
                                className: "d-flex text-right justify-content-center align-content-center",
                                children: /*#__PURE__*/ _jsxs(Tooltip, {
                                    title: t("change language"),
                                    onClick: function(e) {
                                        return onClickLanguage();
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(LanguageIcon, {
                                            style: {
                                                fontSize: 30,
                                                cursor: "pointer"
                                            },
                                            className: "me-2"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: language == "th" ? "ภาษาไทย" : "ພາສາລາວ"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Col, {
                                xs: 6,
                                md: 6,
                                lg: 6,
                                xl: 6,
                                className: "d-flex text-right justify-items-end align-items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        className: " btn btn-dg bt-width-120 pb-2",
                                        ref: anchorRef,
                                        id: "composition-button",
                                        "aria-controls": open ? "composition-menu" : undefined,
                                        "aria-expanded": open ? "true" : undefined,
                                        "aria-haspopup": "true",
                                        onClick: handleToggle,
                                        children: t("Contact Method")
                                    }),
                                    /*#__PURE__*/ _jsx(Popper, {
                                        open: open,
                                        anchorEl: anchorRef.current,
                                        role: undefined,
                                        placement: "bottom-start",
                                        transition: true,
                                        disablePortal: true,
                                        children: function(param) {
                                            var TransitionProps = param.TransitionProps, placement = param.placement;
                                            return /*#__PURE__*/ _jsx(Grow, _object_spread_props(_object_spread({}, TransitionProps), {
                                                style: {
                                                    transformOrigin: placement === "bottom-start" ? "left top" : "left bottom"
                                                },
                                                children: /*#__PURE__*/ _jsx(Paper, {
                                                    children: /*#__PURE__*/ _jsx(ClickAwayListener, {
                                                        onClickAway: handleClose,
                                                        children: /*#__PURE__*/ _jsx(MenuList, {
                                                            autoFocusItem: open,
                                                            id: "composition-menu",
                                                            "aria-labelledby": "composition-button",
                                                            onKeyDown: handleListKeyDown,
                                                            children: socialContact.map(function(ele, i) {
                                                                var _ele_SysSocial, _ele_SysSocial1;
                                                                return /*#__PURE__*/ _jsxs(MenuItem, {
                                                                    onClick: handleClose,
                                                                    component: "a",
                                                                    href: (ele === null || ele === void 0 ? void 0 : ele.social_contact_link) || "",
                                                                    target: "_blank",
                                                                    className: "w-[120px]",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("img", {
                                                                            src: ele === null || ele === void 0 ? void 0 : (_ele_SysSocial = ele.SysSocial) === null || _ele_SysSocial === void 0 ? void 0 : _ele_SysSocial.sys_social_icon,
                                                                            className: "me-2",
                                                                            style: {
                                                                                width: 20,
                                                                                height: 20
                                                                            }
                                                                        }),
                                                                        ele === null || ele === void 0 ? void 0 : (_ele_SysSocial1 = ele.SysSocial) === null || _ele_SysSocial1 === void 0 ? void 0 : _ele_SysSocial1.sys_social_name
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    })
                                                })
                                            }));
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        activeKey: String(tabStatus),
                        onSelect: function(selectedKey) {
                            setTabStatus(selectedKey);
                            setTabBrandType(0);
                            setTabPdType(0);
                            setTabCateType(0);
                            setTabSubCateType(0);
                        },
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "0",
                                    children: [
                                        t("all"),
                                        " (",
                                        mainCounts.total,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "1",
                                    children: [
                                        t("best selling products"),
                                        " (",
                                        mainCounts.recommend,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "2",
                                    children: [
                                        t("new product"),
                                        " (",
                                        mainCounts.new,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "3",
                                    children: [
                                        t("promotion"),
                                        " (",
                                        mainCounts.promotion,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "4",
                                    children: [
                                        t("brand"),
                                        " (",
                                        mainCounts.brand,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 px-3 nav-danger",
                                    eventKey: "5",
                                    children: [
                                        t("product type"),
                                        " (",
                                        mainCounts.productType,
                                        ")"
                                    ]
                                })
                            })
                        ]
                    }),
                    tabStatus == 4 && /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        activeKey: String(tabBrandType),
                        onSelect: function(selectedKey) {
                            return setTabBrandType(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: [
                                        t("all"),
                                        " (",
                                        mainCounts.brand,
                                        ")"
                                    ]
                                })
                            }),
                            renderBrandTabs()
                        ]
                    }),
                    tabStatus == 5 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "tc-10  mb-2",
                                children: t("product type")
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabPdType),
                                onSelect: function(selectedKey) {
                                    setTabPdType(selectedKey);
                                    setTabCateType(0);
                                    setTabSubCateType(0);
                                    setTypeCategory([]);
                                    setTypeSubCategory([]);
                                },
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                t("all"),
                                                " (",
                                                mainCounts.productType,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderProducttypeTabs()
                                ]
                            })
                        ]
                    }),
                    tabStatus == 5 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            tabPdType != 0 && /*#__PURE__*/ _jsx("div", {
                                className: "tc-10  mb-2",
                                children: t("category")
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabCateType),
                                onSelect: function(selectedKey) {
                                    setTabCateType(selectedKey);
                                    setTabSubCateType(0);
                                    setTypeSubCategory([]);
                                },
                                className: "mb-3",
                                children: [
                                    tabPdType != 0 && /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                t("all"),
                                                " (",
                                                mainCounts.category,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderCategoryTabs()
                                ]
                            })
                        ]
                    }),
                    tabStatus == 5 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            tabCateType != 0 && /*#__PURE__*/ _jsx("div", {
                                className: "tc-10  mb-2",
                                children: t("subcategories")
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabSubCateType),
                                onSelect: function(selectedKey) {
                                    return setTabSubCateType(selectedKey);
                                },
                                className: "mb-3",
                                children: [
                                    tabCateType != 0 && /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                t("all"),
                                                " (",
                                                mainCounts.categorySub,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderSubCategoryTabs()
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex align-items-center w-[50%]",
                                children: [
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4 form-200 mb-2",
                                        placeholder: t("search product"),
                                        onChange: function(e) {
                                            setFilterText(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-dg bt-width-120 px-2 py-2 ml-2 mb-2 w-[120px]",
                                        onClick: function() {
                                            loadSearchPin();
                                        },
                                        variant: "",
                                        children: t("search")
                                    })
                                ]
                            }),
                            localStorage.getItem("shop_reserve") != undefined && localStorage.getItem("shop_reserve") != null && localStorage.getItem("shop_reserve") != "" && /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx(Badge, {
                                    color: "error",
                                    badgeContent: cartLength,
                                    style: {
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx(Tooltip, {
                                        title: t("cart"),
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            to: cartUrl,
                                            children: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                style: {
                                                    fontSize: 40,
                                                    cursor: "pointer"
                                                }
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex align-items-center w-[50%]",
                                children: [
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4 form-200 mb-2",
                                        placeholder: t("search shop code"),
                                        onChange: function(e) {
                                            setFilterCode(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-dg bt-width-120 px-2 py-2 ml-2 mb-2 w-[120px]",
                                        onClick: function() {
                                            loadSearchBranch();
                                        },
                                        variant: "",
                                        children: t("search")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex align-items-center justify-content-end w-[50%]",
                                children: shopBranch != undefined && shopBranch != null && shopBranch != "" && /*#__PURE__*/ _jsx("div", {
                                    className: "fs-24",
                                    children: shopBranch.name
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "text",
                                className: "form-control mb-2",
                                placeholder: t("search product"),
                                onChange: function(e) {
                                    setFilterText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-dg px-3 py-1 ml-2 mb-2 fs-14",
                                onClick: function() {
                                    loadSearchPin();
                                },
                                variant: "",
                                children: t("search")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "text",
                                className: "form-control mb-2",
                                placeholder: t("search shop code"),
                                onChange: function(e) {
                                    setFilterCode(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-dg px-3 py-1 ml-2 mb-2 fs-14",
                                onClick: function() {
                                    loadSearchBranch();
                                },
                                variant: "",
                                children: t("search")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            shopBranch != undefined && shopBranch != null && shopBranch != "" && /*#__PURE__*/ _jsx("div", {
                                className: "fs-24",
                                children: shopBranch.name
                            }),
                            localStorage.getItem("shop_reserve") != undefined && localStorage.getItem("shop_reserve") != null && localStorage.getItem("shop_reserve") != "" && /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx(Badge, {
                                    color: "error",
                                    badgeContent: cartLength,
                                    style: {
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx(Tooltip, {
                                        title: t("cart"),
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            to: cartUrl,
                                            children: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                style: {
                                                    fontSize: 40,
                                                    cursor: "pointer"
                                                }
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !isMobile ? // สำหรับ Desktop
            /*#__PURE__*/ _jsxs("div", {
                ref: scrollRef,
                style: {
                    height: "1000px",
                    overflowX: "auto",
                    overflowY: "scroll"
                },
                className: "table-scroll-x",
                children: [
                    /*#__PURE__*/ _jsxs("table", {
                        className: "product-table",
                        children: [
                            /*#__PURE__*/ _jsxs("thead", {
                                children: [
                                    /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("number")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("product image")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("product name")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("barcode")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("packaging size")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("suggested selling price")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                colSpan: 2,
                                                children: t("wholesale price")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                rowSpan: 2,
                                                children: t("promotion")
                                            }),
                                            localStorage.getItem("shop_reserve") != undefined && localStorage.getItem("shop_reserve") != null && localStorage.getItem("shop_reserve") != "" && /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        rowSpan: 2
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        rowSpan: 2
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: t("ex vat")
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: t("in vat")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            rowData.length > 0 && /*#__PURE__*/ _jsx("tbody", {
                                children: rowData.map(function(row, i) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            borderBottom: "1px solid #d2d2d2"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: i + 1
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                width: "150",
                                                children: /*#__PURE__*/ _jsx("center", {
                                                    style: {
                                                        width: "150px"
                                                    },
                                                    children: row.cl_catalog_image ? /*#__PURE__*/ _jsx("img", {
                                                        src: row.cl_catalog_image,
                                                        alt: "สินค้า",
                                                        width: "150"
                                                    }) : ""
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: [
                                                    row.cl_catalog_new == 1 && /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[5px] text-danger text-left fs-20",
                                                        style: {
                                                            fontWeight: 500
                                                        },
                                                        children: "NEW"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[10px] text-left",
                                                        children: language == "la" ? row.cl_catalog_namela : row.cl_catalog_name
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[10px] tc-7 fs-12 text-left",
                                                        children: row.cl_catalog_nameen || ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.ClDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center mb-[22px]",
                                                        children: ele.cl_detail_showbarcode == 1 ? ele.cl_detail_barcode : ""
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.ClDetail.map(function(ele, index) {
                                                    var _ele_SetUnit, _ele_SetUnit1;
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "text-left mb-[22px]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                style: {
                                                                    float: "left",
                                                                    width: "40px"
                                                                },
                                                                children: language == "th" ? " ".concat(((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_name) || "") : " ".concat(((_ele_SetUnit1 = ele.SetUnit) === null || _ele_SetUnit1 === void 0 ? void 0 : _ele_SetUnit1.set_unit_namela) || "")
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "="
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                style: {
                                                                    borderRadius: 5
                                                                },
                                                                children: ele.cl_detail_ratio ? " ".concat(ele.cl_detail_ratio) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: ele.cl_detail_ratio ? " ".concat(t("item")) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " ").concat(t("pack")) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "ms-2 px-2 py-1 rounded-full text-[10px] whitespace-nowrap ".concat(ele.effective_price_source === "SPECIAL" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"),
                                                                children: ele.effective_price_source === "SPECIAL" ? "ราคาพิเศษ" : "Level ".concat(ele.effective_price_level || 1)
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.ClDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "text-right mb-[22px]",
                                                        children: NumberFormat(ele.cl_detail_price, 2)
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.ClDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "".concat(ele.cl_detail_wholesaledis ? "mb-[0px]" : "mb-[22px]"),
                                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            alignContent: "flex-start",
                                                            alignItems: "flex-start",
                                                            children: [
                                                                ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("div", {
                                                                    class: "price-tag",
                                                                    style: {
                                                                        color: "#ffffff"
                                                                    },
                                                                    children: [
                                                                        ele.cl_detail_discount,
                                                                        row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                    ]
                                                                }) : /*#__PURE__*/ _jsx("div", {}),
                                                                /*#__PURE__*/ _jsx(Stack, {
                                                                    direction: "column",
                                                                    justifyContent: "flex-end",
                                                                    alignContent: "flex-end",
                                                                    alignItems: "flex-end",
                                                                    children: ele.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                style: {
                                                                                    color: "#b00312"
                                                                                },
                                                                                children: NumberFormat(ele.cl_detail_wholesaledis ? ele.cl_detail_wholesaledis : 0, 2)
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                class: "old-price",
                                                                                children: NumberFormat(ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0, 2)
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ _jsx("span", {
                                                                        style: // ele.cl_detail_unitid == 6
                                                                        //   ? { color: "#ffffff00" }
                                                                        {
                                                                            color: "#212529"
                                                                        },
                                                                        children: NumberFormat(ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0, 2)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.ClDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "".concat(ele.cl_detail_wholesalevatdis ? "mb-[0px]" : "mb-[22px]"),
                                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            alignContent: "flex-start",
                                                            alignItems: "flex-start",
                                                            children: [
                                                                ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("div", {
                                                                    class: "discount-tag",
                                                                    style: {
                                                                        color: "#ffffff"
                                                                    },
                                                                    children: [
                                                                        ele.cl_detail_discount,
                                                                        row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                    ]
                                                                }) : /*#__PURE__*/ _jsx("div", {}),
                                                                /*#__PURE__*/ _jsx(Stack, {
                                                                    direction: "column",
                                                                    justifyContent: "flex-end",
                                                                    alignContent: "flex-end",
                                                                    alignItems: "flex-end",
                                                                    children: ele.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                style: {
                                                                                    color: "#b00312"
                                                                                },
                                                                                children: NumberFormat(ele.cl_detail_wholesalevatdis ? ele.cl_detail_wholesalevatdis : 0, 2)
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                class: "old-price",
                                                                                children: NumberFormat(ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0, 2)
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ _jsx("span", {
                                                                        style: // ele.cl_detail_unitid == 6
                                                                        //   ? { color: "#ffffff00" }
                                                                        {
                                                                            color: "#212529"
                                                                        },
                                                                        children: NumberFormat(ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0, 2)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px] text-center",
                                                            children: row.SetPromotion.set_promotion_name
                                                        }),
                                                        row.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px] text-center",
                                                            children: row.SetPromotion.set_promotion_buy && row.SetPromotion.set_promotion_free && /*#__PURE__*/ _jsxs(Stack, {
                                                                direction: "row",
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "pt-2 ml-10",
                                                                        children: /*#__PURE__*/ _jsxs("span", {
                                                                            className: "!bg-[#0012fd] text-white px-2 py-1 fs-12",
                                                                            style: {
                                                                                borderRadius: 10
                                                                            },
                                                                            children: [
                                                                                row.SetPromotion.set_promotion_buy ? "".concat(row.SetPromotion.set_promotion_buy, " +") : "",
                                                                                row.SetPromotion.set_promotion_free ? "".concat(row.SetPromotion.set_promotion_free) : ""
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-14",
                                                                        style: {
                                                                            color: "#0012fd"
                                                                        },
                                                                        children: row.ClDetail.map(function(ele, index) {
                                                                            return /*#__PURE__*/ _jsx("span", {
                                                                                children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            children: t("average per pack")
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            children: ele.cl_detail_wholesaleavg
                                                                                        })
                                                                                    ]
                                                                                }) : ""
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "mb-[10px] text-center",
                                                            children: [
                                                                moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                                " ",
                                                                "-",
                                                                " ",
                                                                moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                            ]
                                                        })
                                                    ]
                                                }) : "-"
                                            }),
                                            localStorage.getItem("shop_reserve") != undefined && localStorage.getItem("shop_reserve") != null && localStorage.getItem("shop_reserve") != "" && /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        style: {
                                                            padding: "8px"
                                                        },
                                                        children: row.ClDetail.map(function(ele, index) /*#__PURE__*/ {
                                                            var _ele_cl_detail_amount;
                                                            return _jsx("center", {
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    type: "text",
                                                                    inputMode: "numeric",
                                                                    pattern: "[0-9]*",
                                                                    className: "form-control mb-[15px] w-[50px]",
                                                                    value: (_ele_cl_detail_amount = ele.cl_detail_amount) !== null && _ele_cl_detail_amount !== void 0 ? _ele_cl_detail_amount : 0,
                                                                    onChange: function(e) {
                                                                        var result = normalizeQuantityInput(e.target.value);
                                                                        setRowData(function(prev) {
                                                                            return prev.map(function(catalog) {
                                                                                return _object_spread_props(_object_spread({}, catalog), {
                                                                                    ClDetail: catalog.ClDetail.map(function(detail) {
                                                                                        return detail.idDetail === ele.idDetail ? _object_spread_props(_object_spread({}, detail), {
                                                                                            cl_detail_amount: result
                                                                                        }) : detail;
                                                                                    })
                                                                                });
                                                                            });
                                                                        });
                                                                    }
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        style: {
                                                            padding: "8px"
                                                        },
                                                        children: /*#__PURE__*/ _jsx("center", {
                                                            children: /*#__PURE__*/ _jsx(Chip, {
                                                                variant: "outlined",
                                                                icon: /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                                    style: {
                                                                        color: "#FF4F4F",
                                                                        fontSize: 20
                                                                    }
                                                                }),
                                                                label: t("add cart"),
                                                                style: {
                                                                    color: "#FF4F4F",
                                                                    borderColor: "#FF4F4F",
                                                                    fontSize: 12,
                                                                    cursor: "pointer"
                                                                },
                                                                onClick: function() {
                                                                    return onClickCart(row);
                                                                }
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i);
                                })
                            }),
                            rowData.length == 0 && /*#__PURE__*/ _jsx("tbody", {
                                children: /*#__PURE__*/ _jsx("tr", {
                                    children: /*#__PURE__*/ _jsx("td", {
                                        colSpan: 9,
                                        className: "!bg-[#FFF]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "py-5 my-5",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    class: "table-no-result mx-auto mb-4"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    class: "text-center fs-24 tc-13",
                                                    children: t("no list")
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: bottomRef,
                        style: {
                            height: 1
                        }
                    }),
                    loading && rowData.length > 0 && /*#__PURE__*/ _jsxs("div", {
                        style: {
                            padding: "20px",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Spinner, {
                                animation: "grow",
                                size: "sm"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-2 text-muted fs-14",
                                children: "กำลังโหลดเพิ่มเติม..."
                            })
                        ]
                    }),
                    !hasMore && !loading && rowData.length > 0 && /*#__PURE__*/ _jsx("div", {
                        className: "text-center py-3 text-muted fs-14",
                        children: "ไม่มีข้อมูลเพิ่มเติมแล้ว"
                    })
                ]
            }) : // สำหรับ Mobile
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-2",
                ref: scrollRef,
                children: [
                    rowData.map(function(row, i) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "relative mb-3 rounded-xl shadow-md border border-gray-200 overflow-hidden",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-lg shadow",
                                    children: i + 1
                                }),
                                row.cl_catalog_image && /*#__PURE__*/ _jsx("img", {
                                    src: row.cl_catalog_image,
                                    alt: "สินค้า",
                                    className: "w-full h-40 object-contain bg-white"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "pt-1 pb-2 px-2",
                                    children: [
                                        row.cl_catalog_new == 1 && /*#__PURE__*/ _jsx("div", {
                                            className: "font-semibold text-danger fs-14",
                                            children: "NEW"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "font-semibold text-gray-800 text-sm mb-1",
                                            children: language == "la" ? row.cl_catalog_namela : row.cl_catalog_name
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "text-xs text-gray-500 mb-1",
                                            children: row.cl_catalog_nameen || ""
                                        }),
                                        row.ClDetail.map(function(ele, index) /*#__PURE__*/ {
                                            var _ele_SetUnit, _ele_SetUnit1;
                                            var _ele_cl_detail_amount;
                                            return _jsxs("div", {
                                                className: "border-t py-1 text-xs",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center justify-between mb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("span", {
                                                                className: "text-gray-700",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fw-bold me-3",
                                                                        children: ele.cl_detail_barcode
                                                                    }),
                                                                    language == "th" ? ((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_name) || "" : ((_ele_SetUnit1 = ele.SetUnit) === null || _ele_SetUnit1 === void 0 ? void 0 : _ele_SetUnit1.set_unit_namela) || "",
                                                                    ele.cl_detail_ratio && " = ".concat(ele.cl_detail_ratio, " ").concat(ele.cl_detail_ratio ? "  ".concat(t("item")) : "", " ").concat(ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " ").concat(t("pack")) : ""),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "ms-2 px-2 py-1 rounded-full text-[10px] whitespace-nowrap ".concat(ele.effective_price_source === "SPECIAL" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"),
                                                                        children: ele.effective_price_source === "SPECIAL" ? "ราคาพิเศษ" : "Level ".concat(ele.effective_price_level || 1)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "text-gray-700 fw-bold",
                                                                children: NumberFormat(ele.cl_detail_price, 2)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center justify-between",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "grid grid-cols-2 gap-6 text-gray-700 font-medium w-full",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "flex flex-col",
                                                                        children: ele.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            children: "Ex VAT:"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-red-600",
                                                                                            children: NumberFormat(ele.cl_detail_wholesaledis ? ele.cl_detail_wholesaledis : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                                                            className: "!bg-[#e68e99] text-white px-2",
                                                                                            children: [
                                                                                                ele.cl_detail_discount,
                                                                                                row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "line-through text-gray-400",
                                                                                            children: NumberFormat(ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsxs("div", {
                                                                            className: "flex justify-between",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "Ex VAT:"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: NumberFormat(ele.cl_detail_wholesale, 2)
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "flex flex-col",
                                                                        children: ele.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            children: "In VAT:"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-red-600",
                                                                                            children: NumberFormat(ele.cl_detail_wholesalevatdis ? ele.cl_detail_wholesalevatdis : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex justify-between",
                                                                                    children: [
                                                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                                                            className: "!bg-[#74bfeb] text-white px-2",
                                                                                            children: [
                                                                                                ele.cl_detail_discount,
                                                                                                row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "line-through text-gray-400",
                                                                                            children: NumberFormat(ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0, 2)
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsxs("div", {
                                                                            className: "flex justify-between",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: "In VAT:"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    children: NumberFormat(ele.cl_detail_wholesalevat, 2)
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            localStorage.getItem("shop_reserve") && /*#__PURE__*/ _jsx("input", {
                                                                type: "text",
                                                                inputMode: "numeric",
                                                                pattern: "[0-9]*",
                                                                className: "w-16 border rounded-md text-center py-1 ml-2",
                                                                value: (_ele_cl_detail_amount = ele.cl_detail_amount) !== null && _ele_cl_detail_amount !== void 0 ? _ele_cl_detail_amount : 0,
                                                                onChange: function(e) {
                                                                    var result = normalizeQuantityInput(e.target.value);
                                                                    setRowData(function(prev) {
                                                                        return prev.map(function(catalog) {
                                                                            return _object_spread_props(_object_spread({}, catalog), {
                                                                                ClDetail: catalog.ClDetail.map(function(detail) {
                                                                                    return detail.idDetail === ele.idDetail ? _object_spread_props(_object_spread({}, detail), {
                                                                                        cl_detail_amount: result
                                                                                    }) : detail;
                                                                                })
                                                                            });
                                                                        });
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        row.SetPromotion && /*#__PURE__*/ _jsxs("div", {
                                            className: "bg-blue-50 p-2 rounded-lg text-center text-xs text-blue-600",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "font-medium",
                                                    children: row.SetPromotion.set_promotion_name
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                        " ",
                                                        "-",
                                                        " ",
                                                        moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                    ]
                                                })
                                            ]
                                        }),
                                        localStorage.getItem("shop_reserve") && /*#__PURE__*/ _jsxs("button", {
                                            onClick: function() {
                                                return onClickCart(row);
                                            },
                                            className: "mt-1 w-full flex items-center justify-center px-3 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600",
                                            children: [
                                                /*#__PURE__*/ _jsx(ShoppingCartIcon, {
                                                    className: "mr-2",
                                                    style: {
                                                        fontSize: 18
                                                    }
                                                }),
                                                t("add cart")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }),
                    rowData.length == 0 && /*#__PURE__*/ _jsxs("div", {
                        className: "py-5 my-5",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "table-no-result mx-auto mb-4"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-24 tc-13",
                                children: t("no list")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: bottomRef,
                        style: {
                            height: 1
                        }
                    }),
                    loading && rowData.length > 0 && /*#__PURE__*/ _jsxs("div", {
                        style: {
                            padding: "20px",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Spinner, {
                                animation: "grow",
                                size: "sm"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-2 text-muted fs-14",
                                children: "กำลังโหลดเพิ่มเติม..."
                            })
                        ]
                    }),
                    !hasMore && !loading && rowData.length > 0 && /*#__PURE__*/ _jsx("div", {
                        className: "text-center py-3 text-muted fs-14",
                        children: "ไม่มีข้อมูลเพิ่มเติมแล้ว"
                    })
                ]
            }),
            showToTop && /*#__PURE__*/ _jsxs(Button, {
                type: "button",
                className: "catalog-to-top-button",
                onClick: scrollCatalogToTop,
                "aria-label": "To top",
                title: "To top",
                children: [
                    /*#__PURE__*/ _jsx(KeyboardArrowUpIcon, {
                        fontSize: "small"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: "To top"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
